import React, { useEffect, useState } from 'react'
import Api from '../../../../services/Api'
import { getTokenUri } from '../../../../services/NFTMarketPlace/Graphquery'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import { NFTFileFormatsEnum } from '../Cards/DefaultCard'
import { IGeneralCard } from '../Cards/GeneralCard'
import { IActivityDetail } from './ActivityDetail'
import BaseActivity from './BaseActivity'


export default function GeneralActivityDetail({ collection, historyItem, chainId }: IActivityDetail) {
  const { tokenId } = historyItem
  const [tokenUri, setTokenUri] = useState('')
  const [detailTokenItem, setDetailTokenItem] = useState<IGeneralCard | null>(null)

  let tokenName = detailTokenItem && detailTokenItem.name ? detailTokenItem.name : collection.name

  if (detailTokenItem && !detailTokenItem.name) {
    tokenName = detailTokenItem ? `${collection.name} #${tokenId}` : collection.name
  }

  useEffect(() => {
    if (tokenId !== undefined && tokenId !== null && !tokenUri) {
      getTokenUri(collection.tokenAddress, tokenId).then(res => setTokenUri(res))
    }
    if (tokenUri) {
      let newTokenUri = tokenUri
        .replace('ipfs://', 'https://ipfs.io/ipfs/')
        .replace('gateway.pinata.cloud', 'ipfs.io')
        .replace('https://gateway.pinata.cloud/ipfs/', '')
        .replace('http://', 'https://')

      if (collection.hash) {
        if (collection.endString) {
          newTokenUri = `https://ipfs.io/ipfs/${collection.hash}/${tokenId}.${collection.endString}`
        }
        else{
          newTokenUri = `https://ipfs.io/ipfs/${collection.hash}/${tokenId}`
        }
      }

      Api.get(newTokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }

    if (collection.apiLink) {
      let newTokenUri = ''
      if (collection.endString) {
        newTokenUri = `${collection.apiLink}${tokenId}.${collection.endString}`
      }
      else{
        newTokenUri = `${collection.apiLink}${tokenId}`
      }
      
      Api.get(newTokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenUri, collection.tokenAddress, tokenId])

  const mediaSource = detailTokenItem
    ? detailTokenItem?.image?.replace('ipfs://', 'https://ipfs.io/ipfs/').replace('gateway.pinata.cloud', 'ipfs.io')
    : ''

  function getImage() {
    let NFTItem
    if (collection.fileType === 'NFTFileFormatsEnum.VIDEO') {
      NFTItem = (
        <video controls={true} controlsList="nodownload" muted={true} autoPlay={true} width="100%" src={mediaSource} />
      )
    } else if (collection.fileType === 'NFTFileFormatsEnum.AUDIO') {
      NFTItem = <video controls={true} controlsList="nodownload" width="100%" src={mediaSource} />
    } else if (collection.fileType === 'NFTFileFormatsEnum.IMAGE') {
      NFTItem = <img src={mediaSource} alt={tokenName} />
    } else {
      NFTItem = <img src={mediaSource} alt={tokenName} />
    }

    return detailTokenItem ? NFTItem : <NFTImageSkeleton />
  }

  return (
    <BaseActivity chainId={chainId} historyItem={historyItem} collection={collection} tokenName={tokenName}>
      {getImage()}
    </BaseActivity>
  )
}
